/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-04 09:49:42
 */
import Mock from 'mockjs'

import audit from './audit/audit'
const mocks = [...audit]
Mock.setup({
  timeout: 1000
})
mocks.forEach(value => {
  Mock.mock(new RegExp(value.path), value.type, config => {
    if (typeof value.response === 'function') {
      return value.response(config)
    } else {
      return value.response
    }
  })
})



// WEBPACK FOOTER //
// ./src/mocks/index.js